import moment from "moment";

import {
  generateQueryParamsFromCustomFilters,
  generateQueryParamsFromFilterParams,
  generateQueryParamsFromListFilters,
  generateQueryParamsFromTagFilters,
} from "components/BaseTableV3/table-helpers";

// Legacy AdvancedSearch stored a saved search as
// { filterParams, tagsFilters, customFilters, listFiltersState }. Reuse the same
// helpers the live table uses to flatten that into the flat URL query params the
// new panel already applies and parses, so old saved searches keep working
// without a re-save.

// dateRange values were moment instances that JSON serialized to strings;
// generateQueryParamsFromFilterParams calls `.format()` on them, so restore the
// moments first.
const rehydrateDateRanges = (filterParams, filters) =>
  Object.fromEntries(
    Object.entries(filterParams).map(([title, value]) => {
      const filter = filters.find(f => f.title === title);
      if (filter?.type !== "dateRange" || !value || typeof value !== "object") {
        return [title, value];
      }
      const bounds = Object.fromEntries(
        Object.entries(value).map(([bound, date]) => [
          bound,
          date ? moment(date) : date,
        ])
      );
      return [title, bounds];
    })
  );

export const legacyFilterToQueryParams = (state = {}, filters = []) => {
  const {
    filterParams = {},
    tagsFilters = [],
    customFilters = [],
    listFiltersState = {},
  } = state;

  const { tags } = generateQueryParamsFromTagFilters(tagsFilters);

  return {
    ...generateQueryParamsFromFilterParams(
      rehydrateDateRanges(filterParams, filters),
      filters
    ),
    ...generateQueryParamsFromCustomFilters(customFilters),
    ...generateQueryParamsFromListFilters(listFiltersState, filters),
    ...(tags ? { tags } : {}),
  };
};
